import { AxiosMethods, BannerNotificationsApi } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';

// Permanently dismiss a banner for the current user. Idempotent server-side
// (returns 204), so retrying/duplicate calls are safe.
export const dismissBannerNotificationMutation = () => ({
  mutationFn: (id: string) =>
    axiosHelper({
      endpoint: BannerNotificationsApi.Dismiss.replace(':id', id),
      method: AxiosMethods.POST,
      baseURL: process.env.REVOPS_API
    })
});
